export interface Brand {
  name: string;
  logo: string | null;
}

export const DEFAULT_BRAND: Brand = { name: "MegaBooker", logo: null };

function validName(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}

function validLogo(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}

export function resolveBrand(override?: Partial<Brand>): Brand {
  const source = override as Partial<Record<string, unknown>> | undefined;

  const name = source && validName(source["name"]) ? (source["name"] as string) : DEFAULT_BRAND.name;
  const logo = source && validLogo(source["logo"]) ? (source["logo"] as string) : DEFAULT_BRAND.logo;

  return { name, logo };
}
